import { ProfKindCodesEnum } from 'APIPackage/DictionariesModule/enums/ProfKindCodesEnum';
import { getUserRoleIsSupervisor } from 'AuthPackage/MainModule/selectors/authSelectors';
import { makeGetDictionariesPmProfEventTypesSelectOptions } from 'CorePackage/DictionariesModule/selectors/dictionariesSelectors';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import {
  getKnmIsErknmStatusTypeCompleted,
  getKnmIsErknmStatusTypeWaitingCarryOut,
} from 'KnmPackage/MainModule/selectors/knmSelectors';

import { KnmPmFormFieldsNamesTemplatesEnum } from '../enums/KnmPmFormFieldsNamesTemplatesEnum';

export const getKnmPmInitialFormValues = (state: IRootState) => state.knmPm.initialFormValues;
export const getKnmPmPlanKnmSelectOptions = (state: IRootState) => state.knmPm.planKnmSelectOptions;
export const getKnmPmPlanKnmMessageModalVisible = (state: IRootState) => state.knmPm.planKnmMessageModalState.visible;
export const getKnmPmPlanKnmMessageModalType = (state: IRootState) => state.knmPm.planKnmMessageModalState.type;
export const getKnmPmPlanKnmMessageModalId = (state: IRootState) => state.knmPm.planKnmMessageModalState.id;
export const getKnmPmWasFirstInit = (state: IRootState) => state.knmPm.wasFirstInit;

export const getKnmPmResultDecisionsEditEnabled = (state: IRootState) => {
  return getUserRoleIsSupervisor(state) && getKnmIsErknmStatusTypeCompleted(state);
};

export const getKnmPmWithoutIssueEditEnabled = (state: IRootState) => {
  return (
    getUserRoleIsSupervisor(state) &&
    (getKnmIsErknmStatusTypeCompleted(state) || getKnmIsErknmStatusTypeWaitingCarryOut(state))
  );
};

export const getKnmPmIsUnableToRefuse = (state: IRootState) => state.knmPm.initialFormValues.isUnableToRefuse;

export const getKnmPmProfEventTypesSelectOptions = (state: IRootState) => {
  const getDictionariesPmProfEventTypesSelectOptions = makeGetDictionariesPmProfEventTypesSelectOptions();

  return getDictionariesPmProfEventTypesSelectOptions(state);
};

export const getKnmPmStatusHintText = (state: IRootState) => state.knmPm.statusHintText;
export const getKnmPmStatusHintFields = (state: IRootState) => state.knmPm.statusHintFields;
export const getKnmPmStatusHasHintFields = (state: IRootState) => Boolean(state.knmPm.statusHintFields?.length);
export const getKnmPmTypeFormValue = (state: IRootState) => {
  return state.knm.formRef?.current.getFieldState(KnmPmFormFieldsNamesTemplatesEnum.PM_TYPE)?.value;
};

export const getKnmPmTypeFormValueIsAnnouncementOfWarning = (state: IRootState) =>
  getKnmPmTypeFormValue(state)?.code === ProfKindCodesEnum.OP;

export const getPmStartDate = (state: IRootState) => getKnmPmInitialFormValues(state).startDate;
export const getPmSuspensionEvents = (state: IRootState) => getKnmPmInitialFormValues(state).suspensionEvents;
export const getPmStopDate = (state: IRootState) => getKnmPmInitialFormValues(state).stopDate;
